import { HTMLAttributes, ReactNode } from 'react';

import { cn } from './cn';
import { Skeleton } from './Skeleton';

/** One headline number with its label, for summary panels and dashboards. */
export const StatTile = ({
  label,
  value,
  hint,
  icon,
  loading = false,
  tone = 'default',
  className,
  ...props
}: Omit<HTMLAttributes<HTMLDivElement>, 'children'> & {
  label: ReactNode;
  value: ReactNode;
  hint?: ReactNode;
  icon?: ReactNode;
  loading?: boolean;
  /** `caution` colours the value, for a number that needs attention. */
  tone?: 'default' | 'caution';
}) => (
  <div className={cn('flex items-center gap-3', className)} {...props}>
    {icon && (
      <span className="inline-flex size-8 shrink-0 items-center justify-center rounded-auditor bg-brand-subtle text-brand">
        {icon}
      </span>
    )}
    <div className="flex min-w-0 flex-col gap-0.5">
      <span className="text-xs text-ink-muted">{label}</span>
      {loading ? (
        <Skeleton className="h-7 w-12" />
      ) : (
        <span
          className={cn(
            'text-2xl leading-7 font-semibold tabular-nums tracking-title',
            tone === 'caution' ? 'text-caution-ink' : 'text-ink',
          )}
        >
          {value}
        </span>
      )}
      {hint && <span className="text-caption text-ink-muted">{hint}</span>}
    </div>
  </div>
);
